import { _AdvertisementImgBoxBase } from './advertisementImgBoxBase'

/** 广告图片 css变量实例  */
export class _AdvertisementImgBoxDefault extends _AdvertisementImgBoxBase {
  cssType: 'default' | 'larger' = 'default'
  protected initPC() {
    this['--advertisement-img-box-width'] = '1rem'
    this['--advertisement-img-box-height'] = '1rem'
    return this
  }
  protected initH5() {
    this['--advertisement-img-box-width'] = '1.3rem'
    this['--advertisement-img-box-height'] = '1.3rem'
    return this
  }
}
